import { render, staticRenderFns } from "./DashboardChildNew.vue?vue&type=template&id=7f21bbd7&"
import script from "./DashboardChildNew.vue?vue&type=script&lang=js&"
export * from "./DashboardChildNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports